import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-title-three',
  templateUrl: './title-three.component.html',
  styleUrls: ['./title-three.component.scss'],
})
export class TitleThreeComponent implements OnInit {
  @Input() title: string;

  constructor() {}

  ngOnInit() {}
}
